import { createFileRoute, notFound } from "@tanstack/react-router";
import { CityLandingPage } from "@/components/city/CityLandingPage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";
import { cityInForm, cityToForm } from "@/i18n/city-forms";

const RESERVED = new Set([
  "cities", "eat", "do", "happening", "contact", "help", "ai", "search",
  "login", "register", "onboarding", "profile", "saved", "place",
  "admin", "api", "guides",
]);

export const Route = createFileRoute("/fi/$citySlug")({
  loader: ({ params }) => {
    if (RESERVED.has(params.citySlug)) throw notFound();
    return { citySlug: params.citySlug };
  },
  head: ({ params }) => {
    const slug = params.citySlug;
    const name = slug.charAt(0).toUpperCase() + slug.slice(1).toLowerCase();
    const url = `https://whatfinland.com/fi/${slug}`;
    const inCity = cityInForm("fi", slug, name);
    const toCity = cityToForm("fi", slug, name);
    return {
      meta: [
        { title: `Mitä tehdä ${inCity} — Syö, tee & tapahtumat | what Finland` },
        { name: "description", content: `Suunnittele matkasi ${toCity}: kuratoituja ravintoloita, aktiviteetteja, saunoja, tapahtumia ja lippuja — käsin valittu.` },
        { property: "og:title", content: `Mitä tehdä ${inCity}` },
        { property: "og:description", content: `Kuratoidut ravintolat, tekemiset, saunat ja tapahtumat ${inCity}.` },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks(`/fi/${slug}`),
      ],
    };
  },
  component: CityLandingPage,
});
